import { inject, Injectable } from '@angular/core';
import { QueryClient } from '@tanstack/angular-query-experimental'
import { createCollection } from "@tanstack/db"
import { queryCollectionOptions } from '@tanstack/query-db-collection'

import { Part } from '@dis/models';
import { PartsSheetStore } from './sheetstore';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TanstackDBParts {

  queryClient = inject(QueryClient);

  partsDB = inject(PartsSheetStore);

  partsCollection = createCollection(
    queryCollectionOptions({
      queryKey: ['parts'],
      queryFn:  async () => await firstValueFrom(this.partsDB.collection$()),
      queryClient: this.queryClient,
      getKey: (part: Part) => part.partNumber!,

      onInsert: async ({transaction}) => {
        const newPart = transaction.mutations.map(m => (m.modified))
        await this.partsDB.upsertWithSheetsApi(undefined, newPart[0])
      },

      onUpdate: async ({transaction}) => {
        const updatedPart = transaction.mutations.map(m => ({
          id: m.key,
          modified: m.modified
        }))
        await this.partsDB.upsertWithSheetsApi(updatedPart[0].id, updatedPart[0].modified)
      }
    })
  );
}
